import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-shadow-div',
  templateUrl: './shadow-div.component.html',
  styleUrls: ['./shadow-div.component.scss']
})
export class ShadowDivComponent implements OnInit {

  @Input() col: string = "12";
  @Input() offset: string;
  colOffset: string;

  constructor() { }

  ngOnInit(): void {
    if (!this.offset) {
      this.offset = Math.round((12 - (+this.col))/2).toString();
    }
    this.colOffset = 'col-'+this.col+((+this.offset)>0 ? ' offset-'+this.offset : '');
  }

}
